import {useLocation} from 'react-router-dom';
import {useEffect, useMemo} from 'react';
import Experiences from '../components/experiences/Experiences';
import {useTranslation} from 'react-i18next';
import {scrollToElement, scrollToTop} from '../utils/helpers';
import Header from '../components/Header';
import NavBack from '../components/dashboard/NavBack';
import ErrorPanel from '../components/ErrorPanel';
import Support from '../components/dashboard/Support';
import ChatBot from '../components/Chatbot';
import HeroArea from '../components/dashboard/HeroArea';

const DashboardAll = () => {
  const location = useLocation();
  const state = location.state as {
    customer: HRCustomer;
    jwtToken: string;
  };

  const {t} = useTranslation();

  useEffect(() => {
    scrollToTop();
  }, []);

  const [customer, jwtToken] = useMemo(() => {
    if (state && state.customer && state.jwtToken) {
      return [state.customer, state.jwtToken];
    }

    return [];
  }, [state]);

  return (
    <>
      <Header clientLogo={customer?.logo} clientName={customer?.name} />
      {customer && jwtToken ? (
        <>
          <NavBack />
          <HeroArea
            title={t('dashboard.all-experiences-title')}
            subtitle={t('dashboard.all-experiences-subtitle')}
            refName={customer.name}
            buttonText={t('dashboard.see-plays')}
            onButtonClick={() => scrollToElement('giocate')}
          />

          <div id="giocate">
            <Experiences jwtToken={jwtToken} isSharedOne />
          </div>
          <Support />
          <ChatBot />
        </>
      ) : (
        <ErrorPanel errorMessage={t('errors.generic-error')} />
      )}
    </>
  );
};

export default DashboardAll;
